<template>
    <customModal :containerxl="true" :footerShow="true" @closeModal="closeModal()">
        <template #title> {{ heading }}</template>
        <template #body>
            <div class="table-responsive mt-2 scrollable">
                   <div v-if="!data || data.length === 0" class="text-center py-3">
                     No data found 
                </div>
                <div v-else table class="table table-bordered table-sm" >
                    <thead>
                        <td> Signal ID </td>
                        <td> Category </td>
                        <td> Technique </td>
                        <td> Field Name</td>
                        <td> Observed Metric </td>
                        <td> Outcome </td>
                        <td> Flagged </td>
                    </thead>
                    <tbody>
                        <tr v-for="item in data" :key="item.id">
                            <td>{{ item.signalId }}</td>
                            <td>{{ item.catalogs?.[0]?.category || '-' }}</td>
                            <td>{{ item.linkedTechniqueCode }}</td>
                            <td>{{ item.fieldName }}</td>
                            <td>{{ item.observedMetric }}</td>
                            <td>{{ item.flagType }}</td>
                            <td>{{ item.flagged }}</td>
                        </tr>
                    </tbody>
                </div>
            </div>
        </template>
    </customModal>
</template>
<script src="./DataSignalPopup.js"></script>
<style scoped>

</style>